import ReactQuill from 'react-quill';
import PulseLoader from 'react-spinners/PulseLoader';
import getFilePath from '../../../utils/getFilePath';

function Answer({answer,answered, userQuestionId, changeAnswer}) {
   
    if(!answer || !answer._id)   return <PulseLoader color={"#FFF"} />
    const content = (
        <>
         <label htmlFor={`check=${answer._id}`}>
<div className={`check ${answer._id === answered?' selected ':''}`}>
   
    <input type='radio' 
    id={`check=${answer._id}`}
    autoComplete='off' 
    name={`check-${userQuestionId}`}
    checked={ answer._id === answered}
    value={answer._id}
    onChange={()=>changeAnswer(answer._id)}
     />
    <div>
<ReactQuill
                     theme='bubble'
                    readOnly
                    value={ answer.answerBody}
                    
                    ></ReactQuill>  
   {answer.img && <img className='user-img' src={getFilePath(answer.img)} />}
 
</div>

</div>
     

      

            

</label>  

           
        </>
    )
  return content
}

export default Answer